import AppSite from '../api/appSite';
import { applicationApiExecute, applicationFetchAll, applicationSave } from './applicationActions';

export const saveAppSite = applicationSave(AppSite);
export const fetchAppSites = applicationFetchAll(AppSite);
export const fetchAppStreamAppSites = applicationApiExecute(AppSite.appStream);
